import { it } from "node:test";
import { MediaItem, UploadResult, UploadResponse, UploadedFile } from "../types";
import { getApiUrl } from '../config/api';

// Helper function to get authentication headers
const getAuthHeaders = (additionalHeaders: Record<string, string> = {}): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return {
    ...additionalHeaders,
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};


export const uploadProjectMedia = async (
  files: File[],
  projectId?: string,
  audioUrl?: string,
  enableTrackSplitting: boolean = false  // NEW: Enable track splitting for audio files
): Promise<UploadResult> => {
  const formData = new FormData();
  files.forEach((file) => 
    {
      console.log("mine type -> ",file.type );
      formData.append("files", file);

    }
  )
    
  // Only append projectId if it exists
  if (projectId) {
    formData.append("projectId", projectId);
  }
  if (audioUrl) {
    formData.append("audioUrl", audioUrl);
  }
  
  // NEW: Add enableTrackSplitting parameter for audio files
  formData.append("enableTrackSplitting", enableTrackSplitting.toString());

  // Get authentication headers
  const headers = getAuthHeaders();

  console.log("Uploading Media to Server with authentication...");
  console.log(`🎵 Track splitting enabled: ${enableTrackSplitting}`);
  const response = await fetch(getApiUrl("/media/upload"), {
    method: "POST",
    headers,
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`File upload failed: ${response.statusText}`);
  }

  const data: UploadResponse = await response.json();
  
  return {
    success: true,
    urls: data.files.map(file => file.url),
    projectId: data.projectId,
    uploadedFiles: data.files,
    files: data.files.map(file => ({...file, src: file.url}))// i dont need the blob file in src, its was using temporary memory
  };
};

/**
   * Send the updated media items (with public URLs) along with the audio URL
   * Includes URL cleaning to handle special characters and spaces
   */
  export const sendMediaItems = async (
    mediaItems: MediaItem[],
    audioUrl: string,
    projectId: string
  ): Promise<any> => {
    // Deep clone and clean the mediaItems to handle URL formatting issues
    const cleanedMediaItems = mediaItems.map(item => {
      // Create a new object to avoid mutating the original
      const cleanedItem = {...item, length:item.end-item.start};

      
      // Clean URL and src properties to properly handle spaces
      if (cleanedItem.url) {
        // Ensure spaces are properly encoded in URLs
        cleanedItem.url = cleanedItem.url.replace(/ /g, '%20');
      }
      
      if (cleanedItem.src) {
        // Ensure spaces are properly encoded in src URLs
        cleanedItem.src = cleanedItem.src.replace(/ /g, '%20');
      }
      
      return cleanedItem;
    });
    
    const payload = { projectId, audioUrl, mediaItems: cleanedMediaItems };
    console.log("sending MediaItems to backend ->projectId ->  ", projectId);
    console.log("Cleaned mediaItems URLs for consistency");

    // Get authentication headers with Content-Type
    const headers = getAuthHeaders({ "Content-Type": "application/json" });
  
    const response = await fetch(getApiUrl("/media/create"), {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });
  
    if (!response.ok) {
      throw new Error(`Sending media items failed with status: ${response.status}`);
    }
    const result = await response.json();
    console.log(result);
    return result.videoUrl;
  };
  